'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ActivityTimeline;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * The ActivityTimeline displays each of any item upcoming, current, and past activities.
 * @category Layout
 */


function ActivityTimeline(props) {
  var children = props.children,
      className = props.className,
      style = props.style;

  var getContainerClassName = function getContainerClassName() {
    return (0, _classnames2["default"])('rainbow-activity-timeline_container', className);
  };

  return _react2["default"].createElement('ul', {
    className: getContainerClassName(),
    style: style
  }, children);
}

ActivityTimeline.propTypes = {
  /**
   * This prop that should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes2["default"].oneOfType([_propTypes2["default"].arrayOf(_propTypes2["default"].node), _propTypes2["default"].object]),

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes2["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes2["default"].object
};
ActivityTimeline.defaultProps = {
  children: null,
  className: undefined,
  style: undefined
};